import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterTagsValue,
  UniversalFilterTagsModes,
  UniversalFilterTagsOnChange
} from './UniversalFilterTags.types';

import { useUniversalFilterTags } from './hooks/useUniversalFilterTags';

import { TagsMultiSelect } from '../../../../../main/tags/helpers/TagsMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterTagsProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterTagsValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterTagsOnChange;
}

function UniversalFilterTags({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterTagsProps) {
  const { modeOptions, filterState, handleModeChange, handleTagIdsChange } =
    useUniversalFilterTags({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterTagsModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [UniversalFilterTagsModes.CONTAINS_ANY_OF],
        filterState.mode
      ) ? (
        <TagsMultiSelect
          key={filterState.mode}
          value={filterState.tagIds || []}
          autoFocus={autoFocus}
          onChange={handleTagIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterTags;
